import { SessionStorageEngine } from './session-storage.interface';

/**
 * Browser storage provider
 */
export class SessionStorageBrowserEngine implements SessionStorageEngine
{
    //#region Constructor

    /**
     * Class constructor
     */
    constructor()
    {

    }

    //#endregion

    //#region Methods

    /**
    * Get value in index
    * @param {string} key identifier for data to get
    */
    public getValue(key: string): any
    {
        return sessionStorage.getItem(key);
    }

    /**
     * Set value of index location
     * @param {string} key identifier for data to set
     * @param {any} value value to asign in index location
     */
    public setValue(key: string, value: any)
    {
        sessionStorage.setItem(key, value);
    }

    /**
     * Clears session data
     */
    public clearSessionStorage()
    {
        sessionStorage.clear();
    }

    //#endregion
}
